module.exports = __webpack_public_path__ + "static/media/ginger.227280c7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/apple-watch/silver-aluminum-case/ginger.jpeg
// module id = 2041
// module chunks = 0